import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Github, Twitter, Mail, Linkedin, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    tools: [
      { name: 'BIN Generator', link: '/gen' },
      { name: 'Live Card Checker', link: '/check-live' },
      { name: 'Stripe Validator', link: '/check-stripe' },
      { name: 'Card Testing Tools', link: '/gen' }
    ],
    resources: [
      { name: 'Articles & Guides', link: '/articles' },
      { name: 'API Documentation', link: '/articles' },
      { name: 'FAQs', link: '/faq' },
      { name: 'About Us', link: '/about' },
      { name: 'Contact Support', link: '/contact' }
    ],
    legal: [
      { name: 'Privacy Policy', link: '/privacy' },
      { name: 'Terms of Service', link: '/terms' },
      { name: 'Cookie Policy', link: '/privacy' },
      { name: 'Compliance', link: '/terms' }
    ],
    company: [
      { name: 'About GENMOZPRO', link: '/about' },
      { name: 'Contact Us', link: '/contact' },
      { name: 'FAQs', link: '/faq' }
    ]
  };

  return (
    <footer className="bg-black border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center">
                <CreditCard className="w-5 h-5 text-black" />
              </div>
              <span className="text-xl font-bold">
                <span className="text-yellow-500">GENMOZ</span>
                <span className="text-white">PRO</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-4">
              Professional payment testing tools for developers and security researchers worldwide.
            </p>
            <div className="flex space-x-3">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="GitHub">
                <Github className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Tools */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Tools</h3>
            <ul className="space-y-2">
              {footerLinks.tools.map((link, index) => (
                <li key={`tools-${index}`}>
                  <Link
                    to={link.link}
                    className="text-gray-400 hover:text-yellow-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link, index) => (
                <li key={`resources-${index}`}>
                  <Link
                    to={link.link}
                    className="text-gray-400 hover:text-yellow-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={`company-${index}`}>
                  <Link
                    to={link.link}
                    className="text-gray-400 hover:text-yellow-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link, index) => (
                <li key={`legal-${index}`}>
                  <Link
                    to={link.link}
                    className="text-gray-400 hover:text-yellow-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm text-center md:text-left">
              <p>
                © {currentYear} GENMOZPRO. All rights reserved. | Built for developers, by developers.
              </p>
            </div>

            {/* Additional Links */}
            <div className="flex items-center space-x-6 text-sm">
              <span className="text-gray-400">🔒 SSL Secured</span>
              <span className="text-gray-400">✓ PCI-DSS Compliant</span>
              <span className="text-gray-400">🌍 Global</span>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              GENMOZPRO provides testing tools for developers. All generated data is for testing purposes only.
              Never use real credit card information. Always comply with payment industry standards and regulations.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;